import { GC_MAP_KEY } from "./config/config";


export const _toastVariants = {
  Warn: 'warn',
  Error: 'error',
  Success: 'success'
};

export const _sessionKeys = {
  access_token: 'access_token',
  public_token: 'publicToken',
  loggedInUser: 'loggedInUser'
};

export const _sessionType = {
  getdata: 'getdata',
  removeData: 'removeData',
  setData: 'setData',
};

export const _otpFor = {
  USER_REGISTRATION: 'USER_REGISTRATION',
  USER_LOGIN: 'USER_LOGIN',
  USER_LOGIN_RESEND: 'USER_LOGIN_RESEND'
}

export const _idProofType = {
  AADHAR_CARD: 'Aadhar Card',
  PAN_CARD: 'Pan Card',
  DRIVING_LICENSE: 'Driving License',
  PASSPORT: 'Passport'
}

export const _serviceType = [
  { value: "PRINTING", label: "Printing" },
  { value: "PHOTOSHOOT", label: "Photo shoot" },
  { value: "NOTRY", label: "Notry" },
];


export const GCP_MAP_URLS = {
  addressFromLatLng: (lat, lng) => `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${GC_MAP_KEY}`,
  places: (input = '') => `https://maps.googleapis.com/maps/api/place/autocomplete/json?key=${GC_MAP_KEY}&input=${input}`,
  cords: (placeId) => `https://maps.googleapis.com/maps/api/place/details/json?key=${GC_MAP_KEY}&place_id=${placeId}`,
}

export const _weeks = [

  {
    name: 'Monday',
    series: 1
  },
  {
    name: 'Tuesday',
    series: 2
  },
  {
    name: 'Wednesday',
    series: 3
  },
  {
    name: 'Thrusday',
    series: 4
  },
  {
    name: 'Friday',
    series: 5
  },
  {
    name: 'Saturday',
    series: 6
  },
  {
    name: 'Sunday',
    series: 7
  },
];

export const FILE_UPLOAD_DIR = {
  SHOP: 'shop',
  STAFF: 'staff',
  USER: 'user',
  SOFT_COPY: 'softcopy'
}

export const _staffSpecialist = [{ value: "PHOTOSHOOT", label: "Photo shoot" }, { value: "PRINTING", label: "Printing" }, { value: "NOTARY", label: "Notary" }];

export const _staffLevel = [{ value: "ASSOCIATE", label: "Associate" }, { value: "SPECIALIST", label: "Specialist" }]

export const _status = {
  active: "ACTIVE",
  inactive: "INACTIVE",
  pending: "PENDING"
}

export const DOC_STATUS = {
  'VERIFIED': "VERIFIED",
  'NOT_VERIFIED': "NOT_VERIFIED",
  'PENDING': 'PENDING'
}

export const LABEL_TYPE = {
  STATUS: "STATUS",
  DOC_STATUS: "DOC_STATUS",
  ORDER_STATUS: 'ORDER_STATUS'
}

export const DOCTYPE = {
  ID_PROOF: 'ID_PROOF',
  DOCUMENT: 'DOCUMENT'
}

export const ORDER_STATUS = {
  CREATED: "CREATED", // AUTO
  CONFIRMED: "CONFIRMED", // AUTO
  CANCELLED: "CANCELLED", // MANUAL
  PICKUP: "PICKUP", // MANUAL
  COMPLETED: "COMPLETED", // AUTO
  PAYMENT_FAILED: "PAYMENT_FAILED",// AUTO
  READY_FOR_PICKUP: 'READY_FOR_PICKUP',// MANUALLY
  PHOTO_CAPTURE: 'PHOTO_CAPTURE', // MANUAL
}
export const TIMEZONE = {
  'America/Toronto': 'America/Toronto'
}
export const ORDER_TYPE_ENUM = {
  DOCUMENT_SCAN: "DOCUMENT_SCAN",
  PASSPORT_PHOTO_SHOOT: "PASSPORT_PHOTO_SHOOT",
  COURIER: 'COURIER',
  NOTARY: "NOTARY",
  PHOTOGRAPHY: "PHOTOGRAPHY",

}

export const DISCOUNT_TYPE = {
  PERCENTAGE: 'PERCENTAGE',
  FIXED: 'FIXED'
}

export const DELIVERY_STATUS = {
  REJECTED: "REJECTED",
  PENDING: "PENDING",
  ACCEPTED: "ACCEPTED",
  DELIVERED: "DELIVERED",
  UNDELIVERED: "UNDELIVERED",
  EXPIRED: "EXPIRED"
}

export const USERTYPE_ENUM = {
  'CUSTOMER': 'CUSTOMER',
  'VENDOR': 'VENDOR',
  'SUPER_ADMIN': 'SUPER_ADMIN',
  'RIDER': 'RIDER',
}

export const PRINCT_COLOR_ALIAS = [{ name: 'B&W' }, { name: 'Coloured' }];
export const PRINCT_SIDE = [{ name: 'Single Side' }, { name: 'Both Side' }]
export const PRINT_ADDITIONAL_SERVICES = [{ name: 'Lamination' }, { name: 'Binding' }]


export const SHOP_TYPE_ENUM = {
    STATIC: 'STATIC',
    MOBILE: 'MOBILE'
}

